import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress path — the post lives at the site root, not under /blog/.
export const Route = createFileRoute("/blog/baldness-gene-come-mother-father")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/baldness-gene-come-mother-father/", location.searchStr), statusCode: 301 });
  },
});
